import { lazy } from 'react'
import PublishRosterLoader from './publish/loader'
import RosterTemplatesLoader from './templates/loader'
import CopyLoader from './copy/loader'

export default {
  Publish: {
    Component: lazy(() => import('./publish/PublishRoster.Page')),
    Loader: PublishRosterLoader,
  },
  Templates: {
    Component: lazy(() => import('./templates/RosterTemplates.Page')),
    Loader: RosterTemplatesLoader,
  },
  Copy: {
    Component: lazy(() => import('./copy/CopyRoster.Page')),
    Loader: CopyLoader,
  },
}
